import { ActionReducerMap } from '@ngrx/store';
import { CompaniesEffects } from './companies/companies.effects';
import { ErrorsEffects } from './errors/errors.effects';
import { PermissionsEffects } from './permissions/permissions.effects';
import {
    permissionsReducer,
    PermissionsState,
} from './permissions/permissions.reducer';
import { RouteEffects } from './route/route.effects';
import { SitesEffects } from './sites/sites.effects';
import {
    companiesReducer,
    CompaniesState,
} from './companies/companies.reducer';
import { routeReducer, RouteState } from './route/route.reducer';
import { sitesReducer, SitesState } from './sites/sites.reducer';
import { SnackBarEffects } from './snack-bar/snack-bar.effects';
import { insightsReducer, InsightsState } from './insights/insights.reducer';
import { InsightsEffects } from './insights/insights.effects';
import { MonitoringEffects } from './monitoring/monitoring.effects';
import { monitoringReducer, MonitoringState } from './monitoring/monitoring.reducer';
import { DeploymentEffects } from './deployment/deployment.effects';
import { deploymentReducer, DeploymentState } from './deployment/deployment.reducer';
import { FlowsEffects } from './flows/flows.effects';
import { flowsReducer, FlowsState } from './flows/flows.reducer';
import { PlayerEffects } from './player/player.effects';
import { playerReducer, PlayerState } from './player/player.reducer';
import { SupportEffects } from './support/support.effects';
import { supportReducer, SupportState } from './support/support.reducer';
import { ConfigEffects } from './config/config.effects';
import { configReducer, ConfigState } from './config/config.reducer';

export const effects = [
    ConfigEffects,
    CompaniesEffects,
    SitesEffects,
    MonitoringEffects,
    DeploymentEffects,
    FlowsEffects,
    PlayerEffects,
    SupportEffects,
    RouteEffects,
    PermissionsEffects,
    ErrorsEffects,
    SnackBarEffects,
    InsightsEffects,
];

export interface AppState {
    config: ConfigState;
    companies: CompaniesState;
    sites: SitesState;
    monitoring: MonitoringState;
    deployment: DeploymentState;
    flows: FlowsState;
    player: PlayerState;
    support: SupportState;
    route: RouteState;
    permissions: PermissionsState;
    insights: InsightsState;
}

export const reducers: ActionReducerMap<AppState> = {
    config: configReducer,
    companies: companiesReducer,
    sites: sitesReducer,
    monitoring: monitoringReducer,
    deployment: deploymentReducer,
    flows: flowsReducer,
    player: playerReducer,
    support: supportReducer,
    route: routeReducer,
    permissions: permissionsReducer,
    insights: insightsReducer,
};
